import ApiService from "@/common/api.service";
const noData = [null, "", undefined, "null"]
import moment from "moment"

const state = {
  churnRateResidential: null,
  churnRateResidentialForCalculation: null,
  churnRateCommercial: null,
  churnRateCommercialForCalculation: null,
  lifetimeValueResidential: null,
  lifetimeValueCommercial: null,
  loadingChurnRateAndLifetimeValue: false,

  timeRangeOptions: [
    {
      name: 'Current Month',
      slug: 'current_month',
      timeRange: () => ({
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Past Month',
      slug: 'past_month',
      timeRange: () => ({
        from: moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Current Quarter',
      slug: 'current_quarter',
      timeRange: () => ({
        from: moment().startOf('quarter').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Past Quarter',
      slug: 'past_quarter',
      timeRange: () => ({
        from: moment().subtract(3, 'month').startOf('quarter').format('YYYY-MM-DD'),
        to: moment().subtract(3, 'month').endOf('quarter').format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Current Year',
      slug: 'current_year',
      timeRange: () => ({
        from: moment().startOf('year').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Past Year', 
      slug: 'past_year',
      timeRange: () => ({
        from: moment().subtract(1, 'year').startOf('year').format('YYYY-MM-DD'),
        to: moment().subtract(1, 'year').endOf('year').format('YYYY-MM-DD')
      })
    },
    { 
      name: 'Custom Time Range',
      slug: 'custom_time_range',
      timeRange: () => ({
        from: moment().startOf('month').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
      })
    },
    { name: 'More Options', slug: 'more_options'},
  ],
  selectedTimeRangeOption: {
    total_sales: { name: 'Current Month', slug: 'current_month' },
    referral_sources: { name: 'Current Month', slug: 'current_month' },
    product_service_sales: { name: 'Current Month', slug: 'current_month' },
    new_lost_residential: { name: 'Current Month', slug: 'current_month' },
    new_lost_commercial: { name: 'Current Month', slug: 'current_month' },
    cancel_reasons_residential: { name: 'Current Month', slug: 'current_month' },
    cancel_reasons_commercial: { name: 'Current Month', slug: 'current_month' },
    average_revenue_residential: { name: 'Current Month', slug: 'current_month' },
    average_revenue_commercial: { name: 'Current Month', slug: 'current_month' },
    active_residential: { name: 'Current Month', slug: 'current_month' },
    active_commercial: { name: 'Current Month', slug: 'current_month' },
    total_payments: { name: 'Current Month', slug: 'current_month' },
    average_clients_per_tech: { name: 'Current Month', slug: 'current_month' },
    average_clients_per_hour: { name: 'Current Month', slug: 'current_month' },
    average_clients_per_route: { name: 'Current Month', slug: 'current_month' },
    churn_rate: { name: 'Current Month', slug: 'current_month' },
    lifetime_value: { name: 'Current Month', slug: 'current_month' },
  },
  timeRange: {
    total_sales: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    referral_sources: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    product_service_sales: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    new_lost_residential: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    new_lost_commercial: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    cancel_reasons_residential: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    cancel_reasons_commercial: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    average_revenue_residential: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    average_revenue_commercial: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    active_residential: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    active_commercial: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    total_payments: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    average_clients_per_tech: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    average_clients_per_hour: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    average_clients_per_route: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    churn_rate: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
    lifetime_value: {
      from: moment().startOf('month').format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD')
    },
  }
}

const getters = {
  timeRangeOptions (state) {
    return state.timeRangeOptions
  },
  selectedTimeRangeOption: (state) => (slug) => {
    return state.selectedTimeRangeOption[slug]
  },
  timeRange: (state) => (slug) => {
    return state.timeRange[slug]
  },
  lifetimeValueResidential(state) {
    return state.lifetimeValueResidential
  },
  lifetimeValueCommercial(state) {
    return state.lifetimeValueCommercial
  },
  churnRateResidential(state) {
    return state.churnRateResidential
  },
  churnRateCommercial(state) {
    return state.churnRateCommercial
  },
  churnRateResidentialForCalculation(state) {
    return state.churnRateResidentialForCalculation
  },
  churnRateCommercialForCalculation(state) {
    return state.churnRateCommercialForCalculation
  },
  loadingChurnRateAndLifetimeValue(state) {
    return state.loadingChurnRateAndLifetimeValue;
  },
  sameTimeRange: (state, getters) => (slug1, slug2) => {
    return !noData.includes(slug1) &&
      !noData.includes(slug2) &&
      slug1 !== slug2 &&
      !noData.includes(getters.timeRange(slug1)) &&
      !noData.includes(getters.timeRange(slug1).from) &&
      !noData.includes(getters.timeRange(slug1).to) &&
      !noData.includes(getters.timeRange(slug2)) &&
      !noData.includes(getters.timeRange(slug2).from) &&
      !noData.includes(getters.timeRange(slug2).to) &&
      getters.timeRange(slug1).from === getters.timeRange(slug2).from &&
      getters.timeRange(slug1).to === getters.timeRange(slug2).to
  }
}

const actions = {
  getChurnRateAndLifetimeValue(context, body) {

    let getBoth = context.getters.sameTimeRange('churn_rate', 'lifetime_value') && body.lifetime_value_active
    let slug = body.slug
    delete body.slug
    delete body.lifetime_value_active

    let getChurnRateResidential = () => {
      return new Promise((resolve, reject) => {
        ApiService.get("/kpi_reports/churn_rate_residential", body)
          .then(response => {
            if (getBoth || slug === 'churn_rate') {
              context.commit('setChurnRateResidential', response.data.residential);
            }
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setChurnRateResidentialForCalculation', response.data.residential);
            }
            resolve(response.data.residential);
          })
          .catch(({response}) => {
            if (getBoth || slug === 'churn_rate') {
              context.commit('setChurnRateResidential', null);
            }
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setChurnRateResidentialForCalculation', null);
            }
            reject(response);
          })
      })
    }
    let getChurnRateCommercial = () => {
      return new Promise((resolve, reject) => {
        ApiService.get("/kpi_reports/churn_rate_commercial", body)
          .then(response => {
            if (getBoth || slug === 'churn_rate') {
              context.commit('setChurnRateCommercial', response.data.commercial);
            }
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setChurnRateCommercialForCalculation', response.data.commercial);
            }
            resolve(response.data.commercial);
          })
          .catch(({response}) => {
            if (getBoth || slug === 'churn_rate') {
              context.commit('setChurnRateCommercial', null);
            }
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setChurnRateCommercialForCalculation', null);
            }
            reject(response);
          })
      })
    }
    let getLifetimeValueResidential = () => {
      return new Promise((resolve, reject) => {
        ApiService.get("/kpi_reports/lifetime_value_residential", body)
          .then(response => {
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setLifetimeValueResidential', response.data.lifetime_value_residential);
            }
            resolve(response.data.lifetime_value_residential);
          })
          .catch(({response}) => {
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setLifetimeValueResidential', null);
            }
            reject(response);
          })
      })
    }
    let getLifetimeValueCommercial = () => {
      return new Promise((resolve, reject) => {
        ApiService.get("/kpi_reports/lifetime_value_commercial", body)
          .then(response => {
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setLifetimeValueCommercial', response.data.lifetime_value_commercial);
            }
            resolve(response.data.lifetime_value_commercial);
          })
          .catch(error => {
            if (getBoth || slug === 'lifetime_value') {
              context.commit('setLifetimeValueCommercial', null);
            }
            reject(error);
          })
      })
    }

    let requests = [
      getChurnRateResidential(),
      getChurnRateCommercial()
    ]
    
    if (getBoth || slug === 'lifetime_value') {
      requests.push(getLifetimeValueResidential())
      requests.push(getLifetimeValueCommercial())
    }

    if (getBoth) {
      context.commit('setLoadingChurnRateAndLifetimeValue', true);
    }
    return new Promise((resolve, reject) => {
      Promise.all(requests)
        .then(responses => {
          if (getBoth) {
            context.commit('setLoadingChurnRateAndLifetimeValue', false);
          }
          resolve(responses);
        })
        .catch(error => {
          if (getBoth) {
            context.commit('setLoadingChurnRateAndLifetimeValue', false);
          }
          reject(error);
        })
    })

  },
  setTimeRangeState ({commit, dispatch}, data) {
    commit('setTimeRangeState', data)
    if(noData.includes(data.component_slug)) {
      dispatch('refreshCharts', data)
    }
  },
  refreshCharts ({commit}, data) {
  }
}

const mutations = {
  setLifetimeValueResidential(state, data) {
    state.lifetimeValueResidential = data;
  },
  setLifetimeValueCommercial(state, data) {
    state.lifetimeValueCommercial = data;
  },
  setChurnRateResidential(state, data) {
    state.churnRateResidential = data;
  },
  setChurnRateResidentialForCalculation(state, data) {
    state.churnRateResidentialForCalculation = data;
  },
  setChurnRateCommercial(state, data) {
    state.churnRateCommercial = data;
  },
  setChurnRateCommercialForCalculation(state, data) {
    state.churnRateCommercialForCalculation = data;
  },
  setLoadingChurnRateAndLifetimeValue (state, data) {
    state.loadingChurnRateAndLifetimeValue = data;
  },
  setTimeRangeState(state, data) {
    let out = _.cloneDeep(data)
    delete out.component_slug
    if(data.component_slug) {
      state.timeRange[data.component_slug] = out.timeRange()
      state.selectedTimeRangeOption[data.component_slug] = out
    } else {
      let timeRangekeys = Object.keys(state.timeRange)
      let selectedTimeRangeOptionkeys = Object.keys(state.selectedTimeRangeOption)
      timeRangekeys.forEach(i => {
        state.timeRange[i] = out.timeRange()
      })
      selectedTimeRangeOptionkeys.forEach(i => {
        state.selectedTimeRangeOption[i] = out
      })
    }
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}
